import axios from "axios";
import React, { useEffect, useState } from "react";
import "@fontsource/roboto/400.css";
//import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Alert from "@mui/material/Alert";
import Typography from "@mui/material/Typography";
import { useNavigate } from "react-router-dom";
//import FormLabel from '@mui/material/FormLabel';
//import FormControl from '@mui/material/FormControl';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
//import FormHelperText from '@mui/material/FormHelperText';
import Checkbox from '@mui/material/Checkbox';


function EnvioPaquete() {
  const [apiResponse, setApiResponse] = useState("");
  const [proteccion, setproteccion] = useState("");
  const [valor, setvalor] = useState("");
  const [altura, setaltura] = useState("");
  const [ancho, setancho] = useState("");
  const [largo, setlargo] = useState("");
  const [peso, setpeso] = useState("");
  const loggedIn = sessionStorage.getItem("loggedIn");
  const lastid = sessionStorage.getItem("lastid");
  const seguimientoID = sessionStorage.getItem("seguimientoID");
  const userData = JSON.parse(sessionStorage.getItem("userData"));
  //const clienteID = sessionStorage.getItem("email");
  const clienteid = userData?.clienteid;
  const navigate = useNavigate();
  
//Google Maps
  

//Google Maps

    useEffect(() => {
        if (!loggedIn) {
            navigate("/login");
        }
    }, []);


  //const handleproteccionChange = (event) => {

 //   setproteccion(event.target.value);
//  };

  const handleproteccionChange = (event) => {
    setproteccion({
      ...protec,
      [event.target.name]: event.target.checked,
    });
  };

  const { protec } = setproteccion;

  const handlevalorChange = (event) => {
    setvalor(event.target.value);
  };
  
  const handlealturaChange = (event) => {
    setaltura(event.target.value);
  };
  
  const handleanchoChange = (event) => {
    setancho(event.target.value);
  };
  
  const handlelargoChange = (event) => {
    setlargo(event.target.value);
  };
  
  const handlepesoChange = (event) => {
    setpeso(event.target.value);
  };
  
  const handleSubmit = (event) => {
    event.preventDefault();

    //console.log(proteccion.proteccion);
    //console.log(protec);

    axios
      .post("https://boxerlogistica.com/api/Nuevo_Paquete.php", {
        proteccion: proteccion.proteccion,
        valor: valor,
        lastid: lastid,
        seguimientoID: seguimientoID,
        clienteid: clienteid,
        altura: altura,
        ancho: ancho,
        largo: largo,
        peso: peso
      })
      .then((response) => {
        //console.log(response);
        setApiResponse(response.data.status);
        if (response.data.status === "success") {
          window.location.href = "/EnvioCorrecto";
        }else{
          window.location.href = "/Envioerror";
        }
      })
      .catch((error) => {
        console.error(error);
        setApiResponse(error.response.data.message);
      });
  };



  return (

  <Container>
      <form onSubmit={handleSubmit}>
   {apiResponse && (
            <Alert
              style={{ marginBottom: "20px" }}
              severity={apiResponse.includes("success") ? "success" : "error"}
            >
              {apiResponse}
            </Alert>
          )}
          <div>
                        <Typography variant="h4" gutterBottom>
                            Seleccione sus opciones.
                        </Typography>
                            <br></br> 

          <div className="Inicio-envio">
            <div className="envio-container" >
                        <div className="div-left_envio">
                            <div className="envio">
                            <img src="/images/box.png" alt="Trackbox Logistic Paquete"></img>
                            </div>
                        </div>
                        <div className="div-right_envio">
                            <div className="envio">
                                   <div className="row">
                                      <div className="col-25">
                                          <label>Su Embalaje</label>
                                      </div>
                                      <div className="col-75">
                                      <label>Ingrese el peso y las dimensiones de su paquete</label>
                                      </div>
                                   </div>
                                   <div className="row">
                                      <div className="col-25">
                                         <label>Detalles del paquete</label>
                                      </div>
                                      <div className="col-75">
                                      <label>Peso del paquete </label> 
                                          <br></br>
                                          <br></br>
                                          <div className="box_paquete1">
                                                  <TextField
                                                       type="text"
                                                        required
                                                        value={peso}
                                                        onChange={handlepesoChange}
                                                        variant="filled"
                                                        id="filled-basic"
                                                        label="peso"
                                                        fullWidth
                                                        onInvalid={e => e.target.setCustomValidity("Este valor es requerido")}
                                                        onInput={e => e.target.setCustomValidity('')} 
                                                        style={{ marginBottom: "20px" }}
                                                  />
                                          </div>
                                      </div>
                                    </div>
                                    <div className="row">
                                      <div className="col-25">
                                         <label for="direccionDestino">Dimensión del articulo</label>
                                      </div>
                                      <div className="col-75">
                                          <div className="box_paquete1">
                                          <TextField
                                            type="text"
                                            required
                                            value={largo}
                                            onChange={handlelargoChange}
                                            variant="filled"
                                            id="largo"
                                            name="largo"
                                            label="largo(cm)"
                                            //fullWidth
                                            onInvalid={e => e.target.setCustomValidity("Este valor es requerido")}
                                            onInput={e => e.target.setCustomValidity('')} 
                                            style={{ marginBottom: "20px" }}
                                          />
                                          </div>
                                      </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-25">
                                        
                                        </div>
                                        <div className="col-75">
                                          <div className="box_paquete1">
                                          <TextField
                                            type="text"
                                            required
                                            value={ancho}
                                            onChange={handleanchoChange}
                                            variant="filled"
                                            id="ancho"
                                            name="ancho"
                                            label="ancho(cm)"
                                            //fullWidth
                                            style={{ marginBottom: "20px" }}
                                          />
                                          </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-25">
                                        
                                        </div>
                                        <div className="col-75">
                                          <div className="box_paquete1">
                                          <TextField
                                            type="text"
                                            required
                                            value={altura}
                                            onChange={handlealturaChange}
                                            variant="filled"
                                            id="altura"
                                            name="altura"
                                            label="alto(cm)"
                                            //fullWidth
                                            onInvalid={e => e.target.setCustomValidity("Este valor es requerido")}
                                            onInput={e => e.target.setCustomValidity('')} 
                                            style={{ marginBottom: "20px" }}
                                          />
                                          </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-25">
                                        
                                        </div>
                                        <div className="col-75">
                                            <div className="box_paquete1">
                                                  <TextField
                                                    type="text"
                                                    required
                                                    value={valor}
                                                    onChange={handlevalorChange}
                                                    variant="filled"
                                                    id="valor"
                                                    name="valor"
                                                    label="$ Valor"
                                                    //fullWidth
                                                    onInvalid={e => e.target.setCustomValidity("Este valor es requerido")}
                                                    onInput={e => e.target.setCustomValidity('')} 
                                                    style={{ marginBottom: "20px" }}
                                                  />
                                            
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-25">
                                        
                                        </div>
                                        <div className="col-75">
                                            <div className="box_paquete1">
                                              <FormGroup>
                                                  <FormControlLabel control={<Checkbox
                                                                          checked={protec} 
                                                                          onChange={handleproteccionChange} 
                                                                          name="proteccion"
                                                                      />} 
                                                                    label="Seguro" />
                                              </FormGroup>
                                            </div>
                                      </div>
                                    </div> 
                                    <div className="row">
                                        <div className="col-25">
                                        
                                        </div>
                                        <div className="col-75">
                                              <Button variant="contained" type="submit">
                                                Continuar
                                              </Button>
                                        </div>
                                    </div>
                            </div>
                                          
                        </div>    
            </div>
          </div>
        </div>
        </form>
        
  </Container>          
  );
}

export default EnvioPaquete;
